import axiosInsAcademy from '@/api/axios-ugems-academy';
import { GET_COURSE_BY_ID } from '@/api/master-data/course-catalog/course-catalog';

export default {
  // Get all courses for Mitra Enrollment Report
  getCourses(params) {
    return axiosInsAcademy.get('/tna/partner/enrollment/reports', { params });
  },

  // Get course detail - using course-catalog API
  getCourseDetail(id) {
    return GET_COURSE_BY_ID(id);
  },

  // Get batches for approval
  getBatchesApproval(courseId, params) {
    return axiosInsAcademy.get(`/tna/partner/courses/${courseId}/batches-approval`, { params });
  },

  // Approve participants for a batch
  approveParticipants(batchId, data) {
    return axiosInsAcademy.post(`/tna/partner/enrollment/${batchId}/approval`, data);
  },

  // Reject participants for a batch
  rejectParticipants(batchId, data) {
    return axiosInsAcademy.post(`/tna/partner/enrollment/${batchId}/rejection`, data);
  },

  // Get TNA summary statistics
  getSummary(params) {
    return axiosInsAcademy.get('/tna/hse/summary', { params });
  }
};
